import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Header from "@components/Header/Header";
import Div from "@components/Div";
import { HEADER_MENU_ITEMS, ROUTES, SVLANG } from "@utils/constant";
import { H1 as Heading, H4 } from "@components/Heading";
import { PrimaryButton } from "@components/Button";
import LoginBg from "@assets/login-bg.svg";
import { breakpoints } from "@utils/breakpoints";
import { setPageTitle, setPageType } from "@app/reducers/headerReducer";
import { isAuthenticated } from "@utils/utils";

const { tabletLandscape } = breakpoints;
const breakpoint = {
  mobile: `(max-width: ${tabletLandscape}px)`,
};

export const Container = styled(Div)`
  display: flex;
  min-height: 100vh;
  background-size: 500px;
  background-repeat: no-repeat;
  background-position: center;
  margin: auto;
  @media ${breakpoint.mobile} {
    margin: 0;
    width: 100%;
    background-size: 440px;
  }
`;

export const H1 = styled(Heading)`
  color: var(--blue-light);
  font-size: var(--fs-max);
  font-weight: var(--black-weight);
`;

const Error = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(""));
    dispatch(setPageType(false));
  }, [dispatch]);

  const handleRedirectToHome = () => {
    history.push(ROUTES.HOME.URL);
  };

  return (
    <Container
      width={[1, 1, 1, 1200]}
      height="100vh"
      display="flex"
      flexDirection="column"
      backgroundImage={`url(${LoginBg})`}
    >
      {isAuthenticated() && <Header menuItems={HEADER_MENU_ITEMS} />}
      <Div width={1} display="flex" m="auto">
        <Div display="flex" flexDirection="column" justifyContent="center">
          <H1 mb={3}>{SVLANG.header_error_message}</H1>
          <H4 mb={2}>{SVLANG.text_error_description}</H4>
          <H4 pb={2}>{SVLANG.text_error_message}</H4>
          <PrimaryButton
            width="fit-content"
            mt={4}
            onClick={handleRedirectToHome}
          >
            {SVLANG.button_back_to_start}
          </PrimaryButton>
        </Div>
      </Div>
    </Container>
  );
};

export default Error;
